import { render, staticRenderFns } from "./FundReportFormTab.vue?vue&type=template&id=efb9d9c2&"
import script from "./FundReportFormTab.vue?vue&type=script&lang=js&"
export * from "./FundReportFormTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports